 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		214: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + {"0":"5eeec17","1":"9bdc840","2":"2ffd468","3":"fafca62","4":"96f6217","5":"da374b4","6":"9b4b953","7":"9056c17","8":"9bd0a72","9":"94c82df","10":"ff01b9c","11":"5695e09","12":"bd822d6","13":"58d8398","14":"d441c8f","15":"82305a3","16":"bc52d33","17":"31af145","18":"e03acee","19":"47ee092","20":"1f1e528","21":"6c9d588","22":"d5b59f3","23":"ca31fe3","24":"17dfdfa","25":"1a0e47c","26":"7b06764","27":"adddfda","28":"6c56a70","29":"d4ea55d","30":"1a7d186","31":"97327e4","32":"f2c08d8","33":"6bc3213","34":"e92bc5e","35":"91e803a","36":"32d7c38","37":"fcbd1e2","38":"d80dba7","39":"08c7744","40":"ed943fc","41":"2f65d32","42":"98b86e9","43":"61fc7c9","44":"c11d2b8","45":"c46936e","46":"a238259","47":"5e1e119","48":"1e4aac9","49":"62fa9ef","50":"d451ddb","51":"72bc66c","52":"4192e86","53":"224d4be","54":"384ebad","55":"cd1a152","56":"209d2eb","57":"024fab3","58":"eed8928","59":"6038f65","60":"7f82242","61":"6ac7c89","62":"675a9ae","63":"f6266c4","64":"317f2f8","65":"cb38978","66":"5e1886f","67":"77b8982","68":"22934ac","69":"7c43a39","70":"0555ab7","71":"7e0e345","72":"fa13813","73":"433b96f","74":"102400d","75":"6d7d48b","76":"bdc1dc2","77":"aa682f8","78":"1a4f548","79":"1b56ed4","80":"ad98107","81":"24e5d12","82":"9b0ac84","83":"baf7dc0","84":"4ff36c5","85":"a94f53f","86":"e64c713","87":"d008c30","88":"47651c6","89":"c41b610","90":"373ad2e","91":"04929df","92":"c347cfc","93":"50a3657","94":"41d11e0","95":"e3af945","96":"e656b3a","97":"022facf","98":"09c1e04","99":"1f42830","100":"3c9d3cc","101":"5ba762e","102":"77406ab","103":"78f54e3","104":"48d64f3","105":"cfe255c","106":"9c4fc3f","107":"21ada38","110":"f01a135","111":"94397c1","112":"6622b86","113":"38fa767","114":"7e851fd","115":"4b7da4b","116":"34caa60","117":"4a2a9e5","118":"ee0b8f9","119":"928d15c","120":"ab0ef0a","121":"aa49861","122":"67aceb5","123":"00fdbfa","124":"89421e5","125":"611368b","126":"b5b2dc8","127":"b751183","128":"e4262b0","129":"280c804","130":"dc85ac8","131":"713e114","132":"95d7917","133":"8b6f3f1","134":"029bb5e","135":"4ada872","136":"40f99db","137":"e2164da","138":"ca2cc38","139":"f7619ab","140":"3fa046d","141":"256632c","142":"ed344bb","143":"f9d2f1a","144":"e3a7771","145":"67c91c0","146":"54cea68","147":"bf4d49b","148":"f1e654f","149":"c6ec71a","150":"20d17e2","151":"4c0d756","152":"0616ab8","153":"7a7724b","154":"26ba7ff","155":"cd798da","156":"4af90ce","157":"7b398e2","158":"9108680","159":"c82dec8","160":"bd1c35e","161":"e725d1e","162":"2c7e58d","163":"d3d314e","164":"3cf2b31","165":"2da449a","166":"b7e3ec6","167":"8fae74f","168":"fec8484","169":"6d1138c","170":"3c67e5e","171":"06b5c67","172":"b669385","173":"580a6ae","174":"aea8b31","175":"9435ca8","176":"b3cc993","177":"f6ef1d4","178":"42a39cc","179":"bdd32ef","180":"877d89f","181":"b86772b","182":"ddbe7a5","183":"7d68ba2","184":"54ecd64","185":"c353a5e","186":"e6e4b3b","187":"4dd89cf","188":"cfd5afa","189":"c96425b","190":"d6e97ed","191":"35b52af","192":"42bc2bf","193":"a4f8c95","194":"10bf5b5","195":"9ca7d74","196":"6b69c33","197":"e13eb02","198":"c1e2b2c","199":"7bc3691","200":"07e87db","201":"997913e","202":"7062796","203":"e9242b1","204":"5a8a125","205":"3e1e5ba","206":"be8bac2","207":"0f8d59c","208":"b9758d4","209":"32e15ad","210":"f12d6c3","211":"eee2f5b","212":"59aa73e","213":"c588c80","216":"f9ded39","217":"cc974f7","218":"9b19ad1","219":"3a50a3f","220":"5c1b703","221":"1d4c44f","222":"8eb4536","223":"482684f","224":"7ebc5c9","225":"1ecef57","226":"388879a","227":"de7a156","228":"f2aeac9","229":"db3b6dc","230":"26553bc","231":"4f3db92","232":"158377c","233":"78e6a9c","234":"7ede773","235":"9cff062","236":"8ea12f8","237":"887ee97","238":"f52ddd0","239":"b8c91f6","240":"f300afb","241":"c5c6e90","242":"684b745","243":"8775194","244":"9dac327","245":"1152eee","246":"8216b8e","247":"a4bdc60","248":"ed966fe","249":"f324df8","250":"a3975eb","251":"32f92df","252":"9e65eb0","253":"14d69ec","254":"8171e93","255":"d88a0e0","256":"4bec9b8","257":"18c4410","258":"0917ee1","259":"f6daa77","260":"6ccf8ee","261":"83c1768","262":"ef7d751","263":"ae7d616","264":"b422a29","265":"a1e4814","266":"ffd9770","267":"8c61cd2","268":"f23c917","269":"a2f22af","270":"3f56e34","271":"ba8ee47","272":"81eae4c","273":"bcfb96f","274":"e0e9efa","275":"28910b7","276":"79c3e0a","277":"95d3b32","278":"d5fb1af","279":"415002c","280":"5aacb3b","281":"7367465","282":"2a9d73f","283":"7363dec","284":"8ef47ea","285":"1ca1159","286":"30897be","287":"adedb4b","288":"833d18f","289":"1fc46de","290":"13d137a","291":"8d1c747","292":"f373670","293":"c421309","294":"b8c0bb0","295":"1c8726e","296":"da22911","297":"fdef4d9","298":"659facd","299":"c304753","300":"ac6bbce","301":"441db80","302":"2020fab","303":"0720ee1","304":"4b5f56c","305":"6c46e98","306":"dddd989","307":"e693ac9","308":"5539bd3","309":"d37167f","310":"38343fb","311":"35d5b49","312":"b452cca","313":"cefdd66","314":"c388453","315":"17d5c09","316":"173c238","317":"579e425","318":"95f770a","319":"90f56a7","320":"6adcfe3","321":"b1f106a","322":"079fdb3","323":"1352b27","324":"5fa87d9"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://d1mf56q6wc1y19.cloudfront.net/channels2022/220519/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
